import React from "react";
import moment from "moment";
import ToggleLinksInput from "../../../../parts/inputs/toggle-links-input";
import { DATE_FORMATS } from "../../../../constants";
import { AthleteSelect } from "../../../../parts/inputs/athlete-select-new";
import SvgIcon from "../../../../parts/SvgIcon";

const { DATE_DAY_FORMAT, DATE_YEAR_FORMAT } = DATE_FORMATS;

function TopBarSingleDay({ query, activeDay, isAthlete, dateClassNames = "" }) {
  const url = isAthlete ? "/actions/refresh" : "/dashboard/calendar";

  return (
    <header>
      <section>
        <hgroup>
          <SvgIcon
            classNames="cursor-pointer "
            onClickFn={() => {
              history.back();
            }}
            src={"/img/new-icons/back-button.svg"}
          />

          <a
            href={`${url}?view=day&date=${moment().format(DATE_DAY_FORMAT)}`}
            data-button-type="outline"
            role="button"
          >
            Today
          </a>
        </hgroup>

        <hgroup>
          <div role="month-handler" className={dateClassNames}>
            <div className="!bg-[--dark-grey]">
              <a
                data-button-type="text-white"
                role="button"
                data-icon-only
                href={`${url}?view=day&date=${activeDay
                  .clone()
                  .subtract(1, "day")
                  .format(DATE_DAY_FORMAT)}`}
              >
                <SvgIcon src="/img/new-icons/arrow-left.svg" />
              </a>
              <span className="flex-shrink-0">
                {activeDay.format("MMMM D, YYYY")}
              </span>
              <a
                data-button-type="text-white"
                role="button"
                data-icon-only
                href={`${url}?view=day&date=${activeDay
                  .clone()
                  .add(1, "day")
                  .format(DATE_DAY_FORMAT)}`}
              >
                <SvgIcon src="/img/new-icons/arrow-right.svg" />
              </a>
            </div>
          </div>
        </hgroup>

        <hgroup>
          <ToggleLinksInput
            name="view"
            options={[
              {
                text: "Month",
                value: "month",
                href: `/actions/refresh?view=month&month=${
                  query.week
                    ? moment(query.week, DATE_DAY_FORMAT).format(
                        DATE_YEAR_FORMAT
                      )
                    : query.date
                    ? moment(query.date, DATE_DAY_FORMAT).format(
                        DATE_YEAR_FORMAT
                      )
                    : ""
                }&week=&date=`,
              },
              {
                text: "Week",
                value: "week",
                href: `/actions/refresh?view=week&week=${
                  query.date
                    ? query.date
                    : query.month
                    ? moment(query.month, DATE_YEAR_FORMAT).format(
                        DATE_DAY_FORMAT
                      )
                    : ""
                }&month=&date=`,
              },
              {
                text: "Day",
                value: "day",
                href: `/actions/refresh?view=day&date=${
                  query.month
                    ? moment(query.month, DATE_YEAR_FORMAT).format(
                        DATE_DAY_FORMAT
                      )
                    : query.week
                    ? query.week
                    : ""
                }&month=&week=`,
              },
            ]}
          />
        </hgroup>
      </section>

      <AthleteSelect classNames={"only-show-mobile"} athleteSwitch={true} />
    </header>
  );
}

export default TopBarSingleDay;
